import {EditorState, type Extension} from '@codemirror/state'
import {keymap} from '@codemirror/view'

/**
 * Hack: Forces the CodeMirror editor to function as a single-line editor by configuring the line separator to be nonsense,
 * causing everything in the entire editor to render under a single `cm-line` element. This allows us to control the
 * line breaks ourselves, allowing us to create multi-line marks because, as CodeMirror sees it, they aren't multiline
 * at all. This breaks a lot of CodeMirror's expectations about how the content will behave, but it's no big deal
 * because we aren't using a lot of the features that depend on this anyway.
 */
export const singleLineEditorExtension: Extension = [
  // We have to set the line separator to something, so I used a private unicode character that shouldn't appear in
  // user content since it has no visible representation
  // TODO: Ensure it doesn't appear in user content by filtering it out
  EditorState.lineSeparator.of(String.fromCodePoint(0xe000)),
  // Fix enter key handling since the editor will insert its line separator by default
  keymap.of([
    {
      key: 'Enter',
      run: view => {
        view.dispatch(view.state.update(view.state.replaceSelection('\n'), {scrollIntoView: true, userEvent: 'input'}))
        return true
      },
    },
  ]),
]
